import React from "react";
import "./App2.css";

import NotFound from "./components/NotFound";

import Landing from "./components/Landing";
import Home from "./components/Home";

import WorkoutSelect from "./components/WorkoutSelect";
import WorkoutInit from "./components/WorkoutInit";
import Workout from "./components/Workout";
//import Upgrade from "./components/Upgrade";
import Login from "./components/Login";
import Recovery from "./components/Recovery";
import Register from "./components/Register";
import Payment from "./components/Payment";
import History from "./components/History";
import Radar from "./components/Radar";
import Support from "./components/Support";
import Account from "./components/Account";
import Privacy from "./components/Privacy";
import Terms from "./components/Terms";
import Checkout from "./components/Checkout";

import BestGluteExercises from "./components/BestGluteExercises";
import EightMinutesAbs from "./components/EightMinutesAbs";
import RightBicepCurls from "./components/RightBicepCurls";

import PilatesExercises from "./components/PilatesExercises";
import BallExercise from "./components/BallExercise";
import AbWorkout from "./components/AbWorkout";

//import ScreenJoeSwipeable from "./components/ScreenJoeSwipeable";

import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";

import { Router, Switch, Route, withRouter } from "react-router-dom";
import { createBrowserHistory } from "history";

const snap = navigator.userAgent !== "ReactSnap";
const production = process.env.NODE_ENV === "production";

function initializeFB() {
  if (production && snap) {
    ReactPixel.init("382258349495003");
    ReactPixel.pageView();
    ReactPixel.fbq("track", "PageView");
  }
}

function initializeReactGA() {
  if (production && snap) {
    ReactGA.initialize("UA-148721478-3", {
      gaOptions: {
        cookieDomain: "auto",
      },
    });

    ReactGA.pageview(window.location.pathname + window.location.search);
  }
}

const history = createBrowserHistory();

history.listen((location) => {
  console.log("changed to " + location.pathname);
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

function App() {
  initializeReactGA();
  initializeFB();

  const setViewport = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  window.onresize = function () {
    setTimeout(() => {
      setViewport();
    }, 500);
  };

  setViewport();

  return (
    <Router history={history}>
      <div className="App">
        <Switch>
          <Route key="home" exact path="/" component={withRouter(Home)} />
          <Route
            key="best-glute-exercises"
            exact
            path="/best-glute-exercises"
            component={withRouter(BestGluteExercises)}
          />

          <Route
            key="8-minutes-abs"
            exact
            path="/8-minutes-abs"
            component={withRouter(EightMinutesAbs)}
          />

          <Route
            key="ultimate-bicep-curls"
            exact
            path="/ultimate-bicep-curls"
            component={withRouter(RightBicepCurls)}
          />

          <Route
            key="pilates-exercises"
            exact
            path="/pilates-exercises"
            component={withRouter(PilatesExercises)}
          />

          <Route
            key="ball-exercises"
            exact
            path="/ball-exercises"
            component={withRouter(BallExercise)}
          />

          <Route
            key="perfect-ab-workout"
            exact
            path="/perfect-ab-workout"
            component={withRouter(AbWorkout)}
          />

          {/*
          <Route
            key="upgrade"
            exact
            path="/upgrade"
            component={withRouter(Upgrade)}
          />
          
          */}

          <Route
            key="login"
            exact
            path="/login"
            component={withRouter(Login)}
          />

          <Route
            key="support"
            exact
            path="/support"
            component={withRouter(Support)}
          />

          <Route
            key="account"
            exact
            path="/account"
            component={withRouter(Account)}
          />

          <Route
            key="register"
            exact
            path="/register"
            component={withRouter(Register)}
          />
          <Route
            key="payment"
            exact
            path="/upgrade"
            component={withRouter(Payment)}
          />
          <Route
            key="radar"
            exact
            path="/radar"
            component={withRouter(Radar)}
          />
          <Route
            key="history"
            exact
            path="/history"
            component={withRouter(History)}
          />

          <Route
            key="recovery"
            exact
            path="/recovery"
            component={withRouter(Recovery)}
          />

          <Route
            key="landing"
            exact
            path="/landing"
            component={withRouter(Landing)}
          />

          <Route
            key="workout"
            exact
            path="/workout"
            component={withRouter(Workout)}
          />

          <Route
            key="workoutselect"
            exact
            path="/select-workout"
            component={withRouter(WorkoutSelect)}
          />

          <Route
            key="workoutinit"
            exact
            path="/start-workout/:category"
            component={withRouter(WorkoutInit)}
          />

          <Route
            key="checkout"
            exact
            path="/checkout/:status"
            component={withRouter(Checkout)}
          />

          <Route
            key="privacy"
            exact
            path="/privacy"
            component={withRouter(Privacy)}
          />

          <Route
            key="terms"
            exact
            path="/terms"
            component={withRouter(Terms)}
          />

          <Route path="*" component={NotFound} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
